import { AxiosClient } from "@/app/common/services/http/axios-client.service"
import store from "@/plugins/store"
import { NpsSubmitScoreCommand } from "@/app/nps-feedback/commands/nps-submit-score.command"
import { NpsSubmitFollowUpCommand } from "@/app/nps-feedback/commands/nps-submit-follow-up.command"
import { NpsSubmitFreeAnswerCommand } from "@/app/nps-feedback/commands/nps-submit-free-answer.command"

const httpClient = new AxiosClient()

export const npsSubmitScoreCommand = new NpsSubmitScoreCommand(httpClient, store)
export const npsSubmitFollowUpCommand = new NpsSubmitFollowUpCommand(httpClient, store)
export const npsSubmitFreeAnswerCommand = new NpsSubmitFreeAnswerCommand(httpClient, store)
